'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["TimeZoneFactory", function (TimeZoneFactory) {
    return function (date, format) {
        if (util.isDefined(date) && util.isDefined(format)) {
            return TimeZoneFactory.format(date, format);
        }
    }
}];

